import React, { Component } from 'react'

import { connect } from 'react-redux'

import * as actions from '../actions'
import * as Content from '../reducers/Content'
import EmojiPicker from './EmojiPicker'

const BackButton = (props) => (
  <div
    className={`folderTitleBackButton${props.isRoot ? ' disabled' : ''}`}
    onClick={props.onClick}
  >
    <img
      className="folderTitleBackButtonIcon"
      src="/angle-left.svg"
      alt=""
      draggable="false"
    />
  </div>
)

class FolderTitle extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showsEmojiPicker: false,
    }
  }

  setShowsEmojiPicker = (showsEmojiPicker) => {
    this.setState({ showsEmojiPicker })
  }

  toggleShowsEmojiPicker = () => {
    this.setShowsEmojiPicker(!this.state.showsEmojiPicker)
  }

  onChange = (event) => {
    this.props.setTitle(this.props.folder.id, event.currentTarget.value, true)
  }

  onBlur = (event) => {
    this.props.setNotEditing()
  }

  onClickIcon = (event) => {
    this.toggleShowsEmojiPicker()
  }

  onClickOutsideEmojiPicker = (targetClassName) => {
    if (targetClassName.indexOf('folderTitleIcon') < 0) {
      this.setShowsEmojiPicker(false)
    }
  }

  onClickEmoji = (emoji) => {
    this.props.setIcon(this.props.folder.id, emoji)
    this.setShowsEmojiPicker(false)
  }

  onClickBack = () => {
    this.props.selectParentFolder()
  }

  render() {
    const { isViewOnly, folder, isRoot } = this.props
    const icon = Content.displayIcon(folder, isRoot)
    const title = folder.title ?? ''
    const placeholder = Content.defaultTitle(isRoot)
    const modeClassName = isViewOnly ? 'folderTitle isViewOnly' : 'folderTitle'
    return (
      <div className={modeClassName}>
        <div className="folderTitleContainer">
          <BackButton onClick={this.onClickBack} isRoot={isRoot} />
          <div
            className="folderTitleIcon"
            onClick={(!isViewOnly && this.onClickIcon) || null}
          >
            {icon}
          </div>
          <div className="folderTitleEmojiPickerContainer">
            {this.state.showsEmojiPicker && (
              <EmojiPicker
                onClickEmoji={this.onClickEmoji}
                onClickOutside={this.onClickOutsideEmojiPicker}
              />
            )}
          </div>
          <div className="folderTitleInputContainer">
            {title.length > 0 ? title : placeholder}
            {!isViewOnly && (
              <input
                type="text"
                value={title}
                placeholder={placeholder}
                spellCheck="false"
                onChange={this.onChange}
                onBlur={this.onBlur}
              />
            )}
          </div>
          {isViewOnly && (
            <span className="folderTitleisViewOnlyBadge">View Mode</span>
          )}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {}
}

const ConnectedFolderTitle = connect(mapStateToProps, actions)(FolderTitle)
export default ConnectedFolderTitle
